import { Button, Form, Input, Modal } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import {  AddGroupsList,  UpdateGroupList, axiosErrorMessages } from "../../../../API/api";
import axios, { AxiosError } from "axios";
interface AddEditGroupType {
    isAdd:boolean;
    editData:any
    handleClose: (data: boolean) => void;
  }
    const AddEditGroups: React.FC<AddEditGroupType> = ({ isAdd,editData,handleClose }) => {
    const [isOpen,setIsOpen] = useState<boolean>(true)
    const handleCloseAddEditPopup = () => {
      setIsOpen(false)
      handleClose(true)
    }
      
    const onSaveStatusHandler = (rowData:any) => {
      if(rowData.groupName.trim())  {
        if(isAdd) {
          AddGroupsList(rowData.groupName.trim(), rowData.groupEmailId)
          .then((response:any)  =>{
            enqueueSnackbar("Added Successfully",{ variant: 'success', anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },})
            setIsOpen(false)
            handleClose(true)
    
          }).catch((error:any)  =>  {
            if(error.response.data.errors.Group[0])
            enqueueSnackbar(error.response.data.errors.Group[0],{ variant: 'error', anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          })
            else  {
              let errorMsg;
              if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                errorMsg = axiosErrorMessages(axiosError);
              } else {
                errorMsg = error.message;
              }
              enqueueSnackbar(errorMsg, {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            }
            
          })
    
        }
        else
        {
          if(editData.groupName !== rowData.groupName || editData.groupEmailId !== rowData.groupEmailId)   {
            const saveData = {
              groupId:editData.groupId,
              groupName:rowData.groupName.trim(),
              groupEmailId:rowData.groupEmailId
           }
          UpdateGroupList(saveData)
          .then((response:any)  =>{
            enqueueSnackbar("Updated Successfully",{ variant: 'success', anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },})
            setIsOpen(false)
            handleClose(true)
          }).catch((error:any)  =>  {
              if(error.response.data.errors.Group[0])
            enqueueSnackbar(error.response.data.errors.Group[0],{ variant: 'error', anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          })
            else  {
              let errorMsg;
              if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                errorMsg = axiosErrorMessages(axiosError);
              } else {
                errorMsg = error.message;
              }
              enqueueSnackbar(errorMsg, {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            }
            
          })
          }else {  
            setIsOpen(false)
          handleClose(true)
           } 
      
        }
      }else{
        enqueueSnackbar("Enter Value",{ variant: 'error', anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },})
      }
      
    }

    const handleResetForm = () => {
      addnewSoftwareForm.setFieldsValue({
        groupName:editData.groupName,
        groupEmailId: editData.groupEmailId
      })
    }
    
    const [addnewSoftwareForm] = Form.useForm();
    type FieldType = {
      groupName?: string;
      groupEmailId?: string
         
        };
        useEffect(()=>{
            if(!isAdd)  {
                addnewSoftwareForm.setFieldsValue({
                  groupName:editData.groupName,
                  groupEmailId: editData.groupEmailId
                })
            }
        },[])
    return <> 
    <div>
       <Modal
              footer={null}
              title="Add/Edit Groups"
              open={isOpen}
              onCancel={handleCloseAddEditPopup}
              maskClosable={false}
            >
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            onFinish={onSaveStatusHandler}
            autoComplete="off"
            form={addnewSoftwareForm}
            onReset={handleResetForm}
          >

        <Form.Item<FieldType>
          label="Name"
          name="groupName"
          rules={[{ required: true, message: "Enter Name" }]}
        >
          <Input maxLength={50} />
        </Form.Item>
        <Form.Item<FieldType>
          label="Email ID"
          name="groupEmailId"
          rules={[
            { required: true, message: "Enter Email ID" },
            { type: 'email', message: 'Enter a Valid Email ID'},
        ]}
        >
          <Input maxLength={50} />
        </Form.Item>
    
     
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button className="pm-btn" type="primary" htmlType="submit">
          Save
        </Button>
        {!isAdd && <Button style={{marginLeft:20}} className="pm-btn" type="primary" htmlType="reset">
          Reset
        </Button>}
        </Form.Item>
      </Form>
            </Modal>


        </div>
    </>
}

export default AddEditGroups;